import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { Dates } from "pages/admin/carbonPrograms/Dates";
import { Overview } from "pages/admin/carbonPrograms/Overview";
import { Participation } from "pages/admin/carbonPrograms/Participation";
import { Drafts } from "pages/admin/carbonPrograms/drafts/Drafts";

export const CarbonPrograms = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Carbon Programs",
      key: "overview",
      component: <Overview />,
    },
    {
      name: "Carbon Program Participation",
      key: "participation",
      component: <Participation />,
    },
    {
      name: "Carbon Program Dates",
      key: "dates",
      component: <Dates />,
    },
    {
      name: "Program Drafts",
      key: "drafts",
      component: <Drafts />,
    },
  ];

  const getTabItems = () =>
    tabList.map((tab) => ({
      label: tab.name,
      key: tab.key,
      children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
      disabled: !checkAdminAccess(user?.role, `carbon-programs/${tab.key}`),
    }));

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs
        activeKey={currentSection}
        size="small"
        onChange={(v) => navigate({ pathname: `/carbon-programs/${v}` }, { replace: true })}
        items={getTabItems()}
      />
    </MainPage>
  );
};
